import { createMuiTheme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import Blue from "@material-ui/core/colors/blue";
import Grey from "@material-ui/core/colors/grey";
import { css } from "styled-components";

// Use https://material-ui.com/style/color/#color-tool
// or the more advanced https://material.io/tools/color/
// for picking the right colors for the app

export const defaultMuiTheme = createMuiTheme({
  palette: {
    secondary: red,
    primary: Blue,
    textSecondary: Grey[100],
    error: {
      main: "#3c5f9b",
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: "'Jura', sans-serif",
  },
});

export const styling = {
  // Some standard sizes (use 'rem' as a unit)
  grid: 0.5,
  smallGrid: 0.25,
  padding: 0.5 * 2,

  marginSmall: 0.5,
  margin: 0.5 * 2,
  marginLarge: 0.5 * 3,
  marginHuge: 0.5 * 4,
  marginMassive: 0.5 * 6,
  MarginExtreme: 0.5 * 15,

  blobPadding: "30px",
  blobMargin: 0.5 * 4,

  boxShadow: "box-shadow: 0px 0px 5px 0px rgba(168, 166, 168, 1)",

  // The edge to the left and right of the entire page
  edge: 0.5 * 3,

  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  fontSize: {
    large: "1.5rem",
    sub: "1.25rem",
    normal: "1rem",
    small: "0.85rem",
  },

  breakpointNumbers: {
    phone: 599,
    tabletPortraitUp: 600,
    tabletLandscapeUp: 900,
    desktopSmall: 1050,
    desktopUp: 1200, // 720p
    desktopLargeUp: 1900, // 1080p
  },

  init() {
    // build breakpoints string object.
    this.breakpoints = {};
    Object.keys(this.breakpointNumbers).forEach(key => {
      this.breakpoints[key] = `${this.breakpointNumbers[key]}px`;
    });
  },

  orangeGradientTop: "#253d91",
  orangeGradientBottom: "#22225e",
  greenGradientTop: "#3c5f9b",
  greenGradientBottom: "#5e79ac",
  blueGradientTop: "#5657aa",
  blueGradientBottom: "#9997c9",

  green: "#1d845f",
  blue: "#253d91",
  orange: "#3c5f9b",
  bordeauxRed: "#5F021F",
  greenDisabled: "#C6E0D7",
  blueDisabled: "#C8D9DE",
  orangeDisabled: "#F9DFD5",
  bordeauxRedDisabled: "#D7C0C7",
  black: "#000000",

  dividerColor: "#eee",
  borderColor: "#454546",
  borderHoverColor: "#79797c",
  hoverColor: "#eee",
  selectedColor: "rgb(238, 238, 238)",
  disabledColor: "#a0a0a0",
  disabledFormColor: "#e8e8e8",

  // ActionButton specific stuff
  buttonColor: "black",
  buttonBorder: "#454546",
  buttonHoverColor: "#333",

  borderRadius: "10px",
  foregroundRounding: "45px",

  phone(...args) {
    return css`
      @media (max-width: ${this.breakpoints.phone}) {
        ${css(...args)};
      }
    `;
  },

  tabletPortraitUp(...args) {
    return css`
      @media (min-width: ${this.breakpoints.tabletPortraitUp}) {
        ${css(...args)};
      }
    `;
  },

  tabletLandscapeUp(...args) {
    return css`
      @media (min-width: ${this.breakpoints.tabletLandscapeUp}) {
        ${css(...args)};
      }
    `;
  },

  desktopUp(...args) {
    return css`
      @media (min-width: ${this.breakpoints.desktopUp}) {
        ${css(...args)};
      }
    `;
  },

  desktopLargeUp(...args) {
    return css`
      @media (min-width: ${this.breakpoints.desktopLargeUp}) {
        ${css(...args)};
      }
    `;
  },

  get palette() {
    return defaultMuiTheme.palette;
  },
};
